import React, { Fragment } from 'react'
import styles from './school-header.styles'
import injectSheet from 'react-jss'
import { PobbleAvatar } from 'pobble-components/dist/pobble-avatar'
import SchoolCounters from './school-counters/school-counters.container'
import TwitterIcon from 'react-icons/lib/fa/twitter'
import GlobeIcon from 'react-icons/lib/fa/globe'

const SchoolHeader = ({
  classes,
  id,
  title,
  location,
  description,
  logo,
  background,
  twitterHandler,
  website
}) => (
  <Fragment>
    <div className={classes.container}>
      <div className={classes.intro}>
        <PobbleAvatar avatar={logo} name={title} className={classes.avatar} />
        <div className={classes.school}>
          <h1 className={classes.title}>{title}</h1>
          <h2 className={classes.location}>{location}</h2>
          <h3 className={classes.details}>
            {twitterHandler && (
              <span>
                <TwitterIcon />{' '}
                <a
                  href={`https://twitter.com/${twitterHandler}`}
                  target="_blank"
                  rel="noreferrer noopener">
                  {twitterHandler}
                </a>
              </span>
            )}
            {website && (
              <span>
                <GlobeIcon />{' '}
                <a href={website} target="_blank" rel="noreferrer noopener">
                  {website}
                </a>
              </span>
            )}
          </h3>
          {description && <p className={classes.desc}>{description}</p>}
        </div>
      </div>
      <SchoolCounters />
      <div
        className={classes.cover}
        style={{ backgroundImage: 'url(' + background + ')' }}
      />
    </div>
    <div className={classes.info}>
      <p className={classes.banner}>
        <strong>Your school’s profile header:</strong> Above is how other users
        will view your school on its profile page. You can edit the information
        displayed to others below.{' '}
        <a href={`/schools/${id}`}>View school page</a>
      </p>
    </div>
  </Fragment>
)

export default injectSheet(styles)(SchoolHeader)
